import { Component } from 'react';
import PropTypes from 'prop-types';
import PowerSettings from '@material-ui/icons/PowerSettingsNew';
import Settings from '@material-ui/icons/Settings';
import withStyles from '@material-ui/core/styles/withStyles';
import adminNavbarLinksStyle from 'assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { connect } from 'react-redux';
import { put, get } from 'helpers/apiHelpers';
import {
  handleBrandChange,
  logout,
  refreshLogin,
  setSelectedLanguage,
} from 'actions/Auth';
import { Tooltip } from '@material-ui/core';
import Button from 'components/CustomButtons/Button';

// eslint-disable-next-line import/order -- FIXME
import SelectInput from '../FormSelect/SelectInput';
// eslint-disable-next-line import/order -- FIXME
import { combineStyles, isGranted } from '../../helpers/helpers';

import { withRouter } from 'react-router-dom';

// eslint-disable-next-line import/order -- FIXME
import { ROLE_EDIT_BRAND } from '../../helpers/roles';

import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/uk';
import 'moment/locale/fi';
import 'moment/locale/pl';
import 'moment/locale/ru';
import { compose } from 'redux';
// eslint-disable-next-line no-duplicate-imports -- FIXME
import { fetchLanguages } from 'actions/Auth';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';
import translationEN from 'locales/en.json';
import translationPL from 'locales/pl.json';
import translationLV from 'locales/lv.json';
import translationRU from 'locales/ru.json';
import { toast } from 'react-toastify';

class HeaderLinks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.props.i18n
      .changeLanguage(this.props.user.language)
      // eslint-disable-next-line promise/prefer-await-to-callbacks, no-console -- FIXME
      .catch(error => console.error(error));
    moment.locale(this.props.user.language);
  }

  getLanguages = async () => {
    await this.props.fetchLanguages();

    const selectedLanguage = this.props.languages.find(
      language => language.isoCode === this.props.user.language
    );

    this.setState({
      languageImgUrl: selectedLanguage?.image?.contentUrl,
    });
  };

  componentDidMount() {
    this.getLanguages();
  }

  componentDidUpdate() {
    if (this.state.language !== this.props.i18n.language) {
      this.setState({ language: this.props.i18n.language });
      this.fetchLanguageBeforeChange(this.props.i18n.language);
      moment.locale(this.props.i18n.language);
    }
  }

  handleClick = () => {
    this.setState({ open: !this.state.open });
  };

  // eslint-disable-next-line class-methods-use-this -- FIXME
  fetchLanguageBeforeChange(lang) {
    const DEFAULT_BUNDLES = {
      en: translationEN,
      pl: translationPL,
      lv: translationLV,
      ru: translationRU,
    };
    // eslint-disable-next-line no-async-promise-executor, promise/param-names -- FIXME
    return new Promise(async res => {
      const resource = i18n.getResource(lang, 'translation');

      if (typeof resource === 'undefined') {
        let startedLanguage = {};

        try {
          startedLanguage = await get(
            '/translations/loader/admin/default',
            {},
            { forcedLanguage: lang }
          );
          // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-empty -- FIXME
        } catch (e) {}
        await i18n.addResourceBundle(lang, 'translation', {
          ...(DEFAULT_BUNDLES[lang ?? i18n.language ?? 'pl'] ?? {}),
          ...startedLanguage,
        });
      }
      res(true);
    });
  }

  handleLanguageChange = async ({ target: { value } }, languageObject) => {
    await this.fetchLanguageBeforeChange(value);
    // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks, no-console -- FIXME
    this.props.i18n.changeLanguage(value).catch(error => console.error(error));
    moment.updateLocale(value, {
      week: {
        dow: 1,
      },
    });

    this.saveUserLanguage(value, languageObject);
  };

  saveUserLanguage = (value, languageObject) => {
    put(this.props.user.id, { language: value })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        this.props.setSelectedLanguage(languageObject);
      })
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      .then(() => {
        toast.success(this.props.t('success.dataUpdated'));
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginRight: '15px',
        }}
      >
        {isGranted(ROLE_EDIT_BRAND) && (
          <Button
            round={true}
            justIcon={true}
            simple={true}
            color="transparent"
            onClick={() =>
              this.props.history.push(`/admin/brands/edit/${this.props.brand}`)
            }
          >
            <Settings />
          </Button>
        )}
        <Tooltip
          title={this.props.t(
            'components.navbars.adminNavbarLinks.activeBrandTooltip'
          )}
          placement="left"
        >
          <div style={{ width: '150px' }}>
            <SelectInput
              classes={classes}
              options={this.props.brands}
              mapBy="name"
              trackBy="id"
              value={this.props.brand}
              handleChange={(ev, brand) => {
                this.props.handleBrandChange(ev, { brand, refresh: true });
              }}
            />
          </div>
        </Tooltip>

        {this.props.languages && this.props.adminAllowedToChangeLanguage && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '80px',
              margin: '0 5px',
            }}
          >
            <div
              style={{
                marginRight: '10px',
              }}
            >
              {this.props.selectedLanguage?.image && (
                <img
                  src={
                    process.env.REACT_APP_STATIC_FILES_CDN +
                    this.props.selectedLanguage.image.contentUrl
                  }
                  alt=""
                />
              )}
            </div>
            <SelectInput
              classes={classes}
              options={this.props.languages}
              value={this.props.selectedLanguage}
              trackBy="isoCode"
              mapBy="isoCode"
              handleChange={this.handleLanguageChange}
            />
          </div>
        )}

        <Button
          color="transparent"
          onClick={() => this.props.history.push('/auth/login')}
          style={{ padding: '5px 10px', margin: '0 5px' }}
        >
          <PowerSettings /> {this.props.t('brandCfg.logout')}
        </Button>
      </div>
    );
  }
}

HeaderLinks.propTypes = {
  classes: PropTypes.object.isRequired,
};

const combinedStyles = combineStyles(extendedFormsStyle, adminNavbarLinksStyle);

const mapStateToProps = state => ({
  brands: state.Auth.user.brands,
  brand: state.Auth.selectedBrand,
  user: state.Auth.user,
  adminAllowedToChangeLanguage:
    state.Brands.brand.multinational.adminAllowedToChangeLanguage,
  languages: state.Auth.languages?.filter(lang => lang.enabledForAdmin) || [],
  selectedLanguage: state.Auth.selectedLanguage,
});

const mapDispatchToProps = {
  handleBrandChange,
  logout,
  refreshLogin,
  fetchLanguages,
  setSelectedLanguage,
};

const enhance = compose(
  withStyles(combinedStyles),
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
);

export default enhance(HeaderLinks);
